$bog_ainews_app_sources $bog_ainews_app_page
	runtime_links null
	custom_sources*? /
	title @ \Source
	Logo $mol_icon_open_source_initiative
	body /
		<= My_sources_labeler $mol_labeler
			title @ \Add custom rss feeds:
			content / <= My_sources_labeler_content $mol_list rows /
				<= My $mol_list rows <= My_rss_feeds /
				<= Add_feed_string $mol_string
				<= Add_feed_button $mol_button_minor
					title @ \Add
					click? <=> add_custom_feed_click? null
		<= Sources_labeler $mol_labeler
			title @ \Select your interests:
			content /
				<= Tabs $mol_list rows <= Categories /
				- <= Tabs $mol_deck items <= Categories /
	- Category_page* $mol_list
	Category_page* $mol_labeler
		title <= category_title* \blank category title
		content /
			<= Sources* $mol_select_list
				value? <=> sources*? /
				dictionary <= suggestions* /
			<= Items* $mol_list rows <= articles* /
	My_rss_item* $mol_view
		sub /
			<= RSS_title* $mol_paragraph
				title <= my_rss_title* \
			<= Delete_my_feed_button* $mol_button_major
				sub / <= Delete_close_icon* $mol_icon_close
				click? <=> delete_custom_feed_click*? null
